module.exports = __webpack_public_path__ + "static/enchanted-pond3-57d851c8813ed093d1cbe8bee8830a24.jpg";